export const getXmlTagValue = (xml: string, tag: string) : string | undefined =>
{
  try
  {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xml, 'text/xml');
    var value = xmlDoc.querySelector(tag)?.innerHTML;
    return value;
  }
  catch 
  {
    return undefined;
  }

}